import React from "react";
import { Alert } from "react-native";
import { MedicationsVaccinesStackScreenProps } from "../MedicationsVaccinesNavigator";
import { useSubmitMedicationsVaccines } from "../useSubmitMedicationsVaccines";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";
import { useTranslations } from "@src/packages/i18n";

export function MedicationsVaccinesCompleteScreen({
  navigation,
}: MedicationsVaccinesStackScreenProps<"MedicationsVaccinesComplete">) {
  const t = useTranslations();
  const { submit, isPending } = useSubmitMedicationsVaccines();

  const handleFinish = async () => {
    try {
      await submit();
      navigateToNextSection(navigation, "medicationsVaccines");
    } catch {
      // Draft state stays in context; the user retries with the same button.
      // Navigating (or staying silent) here would fake a successful save
      // and drop the answers on the next refetch (#2219).
      Alert.alert(
        t("med_history.save_failed_title"),
        t("med_history.save_failed_message"),
      );
    }
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.medical.medications_vaccines.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "medicationsVaccines")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}

export default MedicationsVaccinesCompleteScreen;
